import { render } from "./selectProvincia.vue?vue&type=template&id=182b3dac"
import script from "./selectProvincia.vue?vue&type=script&lang=ts"
export * from "./selectProvincia.vue?vue&type=script&lang=ts"
script.render = render

export default script